var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "quality-filters-app" } },
    [
      _c(
        "v-container",
        { staticClass: "quality-filter-container" },
        [
          _c(
            "v-btn-toggle",
            {
              attrs: { multiple: "" },
              model: {
                value: _vm.qualityExclusions,
                callback: function ($$v) {
                  _vm.qualityExclusions = $$v
                },
                expression: "qualityExclusions",
              },
            },
            [
              _vm._l(_vm.items, function (item) {
                return _c(
                  "v-hover",
                  {
                    key: item.value,
                    model: {
                      value: _vm.show[item.value],
                      callback: function ($$v) {
                        _vm.$set(_vm.show, item.value, $$v)
                      },
                      expression: "show[item.value]",
                    },
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "selection-button",
                        attrs: { value: item.value, ripple: false },
                      },
                      [
                        !_vm.qualityExclusions.includes(item.value)
                          ? _c(
                              "span",
                              {
                                staticClass: "quality-btn-icon",
                                class: item.colorClass,
                              },
                              [_c("i", { class: item.icon })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.qualityExclusions.includes(item.value)
                          ? _c(
                              "span",
                              {
                                staticClass: "quality-btn-icon",
                                class: item.colorClass,
                              },
                              [_c("i", { class: item.disabledIcon })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "quality-btn-label",
                            class: item.colorClass,
                          },
                          [_vm._v(_vm._s(item.title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-fade-transition",
                          [
                            _c("v-hover", {
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ hover }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.show[item.value],
                                                expression: "show[item.value]",
                                              },
                                            ],
                                            staticClass: "only-btn",
                                            class: { "on-hover": hover },
                                            attrs: {
                                              value: "Only " + item.title,
                                              color: item.color,
                                              dark: "",
                                              "x-small": "",
                                              absolute: "",
                                              tile: "",
                                              elevation: "0",
                                              ripple: false,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.only(
                                                  item.value,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "only-label" },
                                              [_vm._v("ONLY")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "v-hover",
                {
                  key: "Custom",
                  model: {
                    value: _vm.show["Custom"],
                    callback: function ($$v) {
                      _vm.$set(_vm.show, "Custom", $$v)
                    },
                    expression: "show['Custom']",
                  },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "selection-button",
                      attrs: { value: "Custom", ripple: false },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "semantic-custom quality-btn-icon",
                          class: _vm.hasCustomMetrics ? "svg-custom-box" : "",
                        },
                        [
                          !_vm.hasCustomMetrics
                            ? _c("i", { staticClass: "fas fa-tools" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasCustomMetrics
                            ? _c("i", {
                                staticClass: "fas fa-plus float-left-plus",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasCustomMetrics &&
                          !_vm.qualityExclusions.includes("Custom")
                            ? _c(
                                "svg",
                                {
                                  staticClass:
                                    "custom-metrics-svg svg-custom-offset",
                                  attrs: { width: "16", height: "16" },
                                },
                                [
                                  _c("circle", {
                                    staticClass: "custom-metrics-circle",
                                    attrs: { cx: "8", cy: "8", r: "8" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "text",
                                    {
                                      staticClass: "custom-metrics-text",
                                      attrs: {
                                        x: "50%",
                                        y: "50%",
                                        dy: "0.33em",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.customMetricsLength))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasCustomMetrics &&
                          _vm.qualityExclusions.includes("Custom")
                            ? _c(
                                "svg",
                                {
                                  staticClass:
                                    "custom-metrics-svg svg-custom-offset",
                                  attrs: { width: "16", height: "16" },
                                },
                                [
                                  _c("circle", {
                                    staticClass:
                                      "custom-metrics-circle-outline",
                                    attrs: { cx: "8", cy: "8", r: "7" },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "text",
                                    {
                                      staticClass: "custom-metrics-text-normal",
                                      attrs: {
                                        x: "50%",
                                        y: "50%",
                                        dy: "0.33em",
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.customMetricsLength))]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "semantic-custom quality-btn-label" },
                        [_vm._v(_vm._s(_vm.customTitle))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-fade-transition",
                        [
                          _c("v-hover", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ hover }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.show["Custom"],
                                            expression: "show['Custom']",
                                          },
                                        ],
                                        staticClass: "only-btn",
                                        class: { "on-hover": hover },
                                        attrs: {
                                          value: "Edit Custom",
                                          color: "#8085E9",
                                          dark: "",
                                          "x-small": "",
                                          absolute: "",
                                          tile: "",
                                          elevation: "0",
                                          ripple: false,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.only("Custom", $event)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  EDIT\n                "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _vm.showCustomModal
            ? _c(
                "modal",
                {
                  staticClass: "custom-metrics-modal",
                  attrs: {
                    "header-title": "Custom Call Quality Settings",
                    outsideClickWhitelist: _vm.modalOutsideClickWhitelist,
                  },
                  on: {
                    close: function ($event) {
                      _vm.showCustomModal = false
                    },
                    cancel: function ($event) {
                      _vm.showCustomModal = false
                    },
                  },
                },
                [
                  _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                    _c("table", { staticClass: "metric-tag-table" }, [
                      _c("tr", [
                        _c("td", { staticClass: "mtt-instructions-td" }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "mtt-instructions-td",
                            attrs: { colspan: "8" },
                          },
                          [
                            !_vm.showReset
                              ? _c(
                                  "span",
                                  { staticClass: "mtt-instructions" },
                                  [
                                    _vm._v("Create from scratch, or try a "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "fill-sample",
                                        on: { click: _vm.fillBad },
                                      },
                                      [_vm._v("Pre-filled Sample")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showReset
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "mtt-instructions",
                                    on: { click: _vm.fillReset },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-undo fill-sample",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "fill-sample" }, [
                                      _vm._v("Reset to blank"),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "img-badge-container-alerts" },
                              [
                                _c("img", {
                                  staticClass: "img-badge",
                                  attrs: {
                                    src: "dist/images/badge-beta-yellow.png",
                                    width: "34",
                                    height: "16",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "mtt-title-header mtt-main-title",
                            attrs: { colspan: "2" },
                          },
                          [
                            _c("span", { staticClass: "mtt-header" }, [
                              _vm._v("Audio"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "mtt-title-header mtt-main-title",
                            attrs: { colspan: "2" },
                          },
                          [
                            _c("span", { staticClass: "mtt-header" }, [
                              _vm._v("Video"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "mtt-title-header mtt-main-title",
                            attrs: { colspan: "2" },
                          },
                          [
                            _c("span", { staticClass: "mtt-header" }, [
                              _vm._v("Presentation"),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-title-subheader" }, [
                          _c("span", { staticClass: "mtt-subheader" }, [
                            _vm._v("Send"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-title-subheader" }, [
                          _c("span", { staticClass: "mtt-subheader" }, [
                            _vm._v("Receive"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-title-subheader" }, [
                          _c("span", { staticClass: "mtt-subheader" }, [
                            _vm._v("Send"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-title-subheader" }, [
                          _c("span", { staticClass: "mtt-subheader" }, [
                            _vm._v("Receive"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-title-subheader" }, [
                          _c("span", { staticClass: "mtt-subheader" }, [
                            _vm._v("Send"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-title-subheader" }, [
                          _c("span", { staticClass: "mtt-subheader" }, [
                            _vm._v("Receive"),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        { staticClass: "mtt-data-row mtt-data-row-first" },
                        [
                          _c("td", { staticClass: "mtt-metric" }, [
                            _c(
                              "span",
                              { staticClass: "mtt-header mtt-header-metric" },
                              [_vm._v("Packet Loss")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .tx_audio_packet_loss_rate.operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics
                                          .tx_audio_packet_loss_rate.value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics
                                        .tx_audio_packet_loss_rate.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics
                                          .tx_audio_packet_loss_rate,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.tx_audio_packet_loss_rate.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .tx_audio_packet_loss_rate.suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .rx_audio_packet_loss_rate.operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics
                                          .rx_audio_packet_loss_rate.value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics
                                        .rx_audio_packet_loss_rate.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics
                                          .rx_audio_packet_loss_rate,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.rx_audio_packet_loss_rate.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .rx_audio_packet_loss_rate.suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "mtt-spacer-col" }),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .tx_video_packet_loss_rate.operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics
                                          .tx_video_packet_loss_rate.value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics
                                        .tx_video_packet_loss_rate.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics
                                          .tx_video_packet_loss_rate,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.tx_video_packet_loss_rate.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .tx_video_packet_loss_rate.suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .rx_video_packet_loss_rate.operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics
                                          .rx_video_packet_loss_rate.value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics
                                        .rx_video_packet_loss_rate.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics
                                          .rx_video_packet_loss_rate,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.rx_video_packet_loss_rate.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .rx_video_packet_loss_rate.suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "mtt-spacer-col" }),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .tx_presentation_packet_loss_rate
                                          .operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics
                                          .tx_presentation_packet_loss_rate
                                          .value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics
                                        .tx_presentation_packet_loss_rate.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics
                                          .tx_presentation_packet_loss_rate,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.tx_presentation_packet_loss_rate.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .tx_presentation_packet_loss_rate
                                          .suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .rx_presentation_packet_loss_rate
                                          .operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics
                                          .rx_presentation_packet_loss_rate
                                          .value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics
                                        .rx_presentation_packet_loss_rate.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics
                                          .rx_presentation_packet_loss_rate,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.rx_presentation_packet_loss_rate.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics
                                          .rx_presentation_packet_loss_rate
                                          .suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("tr", { staticClass: "mtt-data-row mtt-odd-row" }, [
                        _c("td", { staticClass: "mtt-metric" }, [
                          _c(
                            "span",
                            { staticClass: "mtt-header mtt-header-metric" },
                            [_vm._v("Jitter")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_audio_jitter.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_audio_jitter.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_audio_jitter.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_audio_jitter,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_audio_jitter.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_audio_jitter.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_audio_jitter.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_audio_jitter.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_audio_jitter.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_audio_jitter,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_audio_jitter.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_audio_jitter.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_jitter.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_video_jitter.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_video_jitter.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_video_jitter,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_video_jitter.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_jitter.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_jitter.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_video_jitter.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_video_jitter.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_video_jitter,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_video_jitter.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_jitter.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_presentation_jitter
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_presentation_jitter
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_presentation_jitter
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_presentation_jitter,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_presentation_jitter.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_presentation_jitter
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_presentation_jitter
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_presentation_jitter
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_presentation_jitter
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_presentation_jitter,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_presentation_jitter.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_presentation_jitter
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "mtt-data-row" }, [
                        _c("td", { staticClass: "mtt-metric" }, [
                          _c(
                            "span",
                            { staticClass: "mtt-header mtt-header-metric" },
                            [_vm._v("Latency")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_audio_latency
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_audio_latency.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_audio_latency.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_audio_latency,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_audio_latency.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_audio_latency.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_audio_latency
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_audio_latency.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_audio_latency.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_audio_latency,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_audio_latency.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_audio_latency.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_latency
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_video_latency.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_video_latency.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_video_latency,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_video_latency.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_latency.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_latency
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_video_latency.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_video_latency.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_video_latency,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_video_latency.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_latency.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_presentation_latency
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_presentation_latency
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_presentation_latency
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_presentation_latency,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_presentation_latency.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_presentation_latency
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_presentation_latency
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_presentation_latency
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_presentation_latency
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_presentation_latency,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_presentation_latency.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_presentation_latency
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "mtt-data-row mtt-odd-row" }, [
                        _c("td", { staticClass: "mtt-metric" }, [
                          _c(
                            "span",
                            { staticClass: "mtt-header mtt-header-metric" },
                            [_vm._v("Resolution")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", { staticClass: "mtt-na" }, [
                            _vm._v("N/A"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", { staticClass: "mtt-na" }, [
                            _vm._v("N/A"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_resolution_y
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_video_resolution_y
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_video_resolution_y
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_video_resolution_y,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_video_resolution_y.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_resolution_y
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_resolution_y
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_video_resolution_y
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_video_resolution_y
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_video_resolution_y,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_video_resolution_y.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_resolution_y
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .tx_presentation_resolution_y.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics
                                        .tx_presentation_resolution_y.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics
                                      .tx_presentation_resolution_y.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics
                                        .tx_presentation_resolution_y,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_presentation_resolution_y.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .tx_presentation_resolution_y.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .rx_presentation_resolution_y.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics
                                        .rx_presentation_resolution_y.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics
                                      .rx_presentation_resolution_y.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics
                                        .rx_presentation_resolution_y,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_presentation_resolution_y.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .rx_presentation_resolution_y.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "mtt-data-row" }, [
                        _c("td", { staticClass: "mtt-metric" }, [
                          _c(
                            "span",
                            { staticClass: "mtt-header mtt-header-metric" },
                            [_vm._v("Framerate")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", { staticClass: "mtt-na" }, [
                            _vm._v("N/A"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("span", { staticClass: "mtt-na" }, [
                            _vm._v("N/A"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_frame_rate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_video_frame_rate
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_video_frame_rate.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_video_frame_rate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_video_frame_rate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_frame_rate
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_frame_rate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_video_frame_rate
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_video_frame_rate.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_video_frame_rate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_video_frame_rate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_frame_rate
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .tx_presentation_frame_rate.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics
                                        .tx_presentation_frame_rate.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_presentation_frame_rate
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics
                                        .tx_presentation_frame_rate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_presentation_frame_rate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .tx_presentation_frame_rate.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .rx_presentation_frame_rate.operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics
                                        .rx_presentation_frame_rate.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_presentation_frame_rate
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics
                                        .rx_presentation_frame_rate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_presentation_frame_rate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics
                                        .rx_presentation_frame_rate.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "mtt-data-row mtt-odd-row" }, [
                        _c("td", { staticClass: "mtt-metric" }, [
                          _c(
                            "span",
                            { staticClass: "mtt-header mtt-header-metric" },
                            [_vm._v("Channel Bitrate")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_audio_bitrate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_audio_bitrate.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_audio_bitrate.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_audio_bitrate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_audio_bitrate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_audio_bitrate.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_audio_bitrate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_audio_bitrate.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_audio_bitrate.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_audio_bitrate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_audio_bitrate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_audio_bitrate.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_bitrate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_video_bitrate.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_video_bitrate.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_video_bitrate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_video_bitrate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_video_bitrate.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_bitrate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_video_bitrate.value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_video_bitrate.value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_video_bitrate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_video_bitrate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_video_bitrate.suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_presentation_bitrate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.tx_presentation_bitrate
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.tx_presentation_bitrate
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.tx_presentation_bitrate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.tx_presentation_bitrate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.tx_presentation_bitrate
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "vy-row center-row",
                              attrs: { "flex-nowrap": "", align: "center" },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_presentation_bitrate
                                        .operator
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "small-text-field",
                                attrs: {
                                  outlined: "",
                                  dense: "",
                                  "single-line": "",
                                  "hide-details": "",
                                  rules: [_vm.rules.integer],
                                },
                                on: {
                                  keypress: function ($event) {
                                    return _vm.isShortInteger(
                                      $event,
                                      _vm.customMetrics.rx_presentation_bitrate
                                        .value
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.customMetrics.rx_presentation_bitrate
                                      .value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.customMetrics.rx_presentation_bitrate,
                                      "value",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression:
                                    "customMetrics.rx_presentation_bitrate.value",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "field-inline-label2" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customMetrics.rx_presentation_bitrate
                                        .suffix
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-row" }),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-row" }),
                      ]),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td"),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "mtt-title-header mtt-submain-title" },
                          [
                            _c("span", { staticClass: "mtt-header" }, [
                              _vm._v("System"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass:
                              "mtt-title-header mtt-submain-title mtt-apps-broder",
                          },
                          [
                            _c("span", { staticClass: "mtt-header" }, [
                              _vm._v("App"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "mtt-spacer-col" }),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "mtt-best-practices-td",
                            attrs: { rowspan: "2", colspan: "4" },
                          },
                          [
                            _c("span", { staticClass: "mtt-instructions" }, [
                              _vm._v(
                                "Setting your own sensitivity levels allows you to precisely customize all"
                              ),
                              _c("br"),
                              _vm._v(
                                "available call metrics to be alerted on.  "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: _vm.brandingService.getSupportUrl(
                                      "customThresholds"
                                    ),
                                    target: "_blank",
                                    title: "best practices",
                                  },
                                },
                                [
                                  _vm._v(
                                    "Click to learn additional best practices"
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "tr",
                        {
                          staticClass:
                            "mtt-data-row mtt-data-row-first mtt-odd-row",
                        },
                        [
                          _c("td", { staticClass: "mtt-metric" }, [
                            _c(
                              "span",
                              { staticClass: "mtt-header mtt-header-metric" },
                              [_vm._v("CPU")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics.device_system_cpu
                                          .operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics.device_system_cpu
                                          .value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics.device_system_cpu.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics.device_system_cpu,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.device_system_cpu.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics.device_system_cpu
                                          .suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              {
                                staticClass: "vy-row center-row",
                                attrs: { "flex-nowrap": "", align: "center" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics.device_app_cpu
                                          .operator
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "small-text-field",
                                  attrs: {
                                    outlined: "",
                                    dense: "",
                                    "single-line": "",
                                    "hide-details": "",
                                    rules: [_vm.rules.decimal],
                                  },
                                  on: {
                                    keypress: function ($event) {
                                      return _vm.isShortDecimal(
                                        $event,
                                        _vm.customMetrics.device_app_cpu.value
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.customMetrics.device_app_cpu.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.customMetrics.device_app_cpu,
                                        "value",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression:
                                      "customMetrics.device_app_cpu.value",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "field-inline-label2" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.customMetrics.device_app_cpu.suffix
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "mtt-spacer-col" }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }